import { data } from '../../svg/Desktop/data';
import { makeIcon } from '../makeIcon';

export const Desktop = makeIcon(data, 'desktop', 'Desktop');

export default Desktop;
